'use strict';

var FlightModeService = function FlightModeService(featureToggleService) {
  function isDAOnlyMode() {
    var isRO = featureToggleService.isEnabled('REVENUE_OPTIMIZER');
    var isDA = featureToggleService.isEnabled('DYNAMIC_AVAILABILITY');
    return isDA && !isRO;
  }
  return {
    isDAOnlyMode: isDAOnlyMode
  };
};
FlightModeService.$inject = ['FeatureToggleService'];
module.exports = FlightModeService;